import React from "react";
import type { ConfirmDialogModel } from "../../type/confirmDialog";
import { cancelIcon, okIcon } from "../../utils/config";
import { BaseModal } from "../../components/modalCommon/modalBase";
import Checkbox from "../../components/checkbox/checkbox";
import { ModalHeader } from "../../components/modalCommon/modalHeader";
import { ModalBody } from "../../components/modalCommon/modalBody";
import { ModalFooter } from "../../components/modalCommon/modalFooter";
import "./confirmDialog.scss";

const ConfirmDialog: React.FC<ConfirmDialogModel> = ({
  isOpen,
  title = "Potwierdzenie",
  message,
  onConfirm,
  onCancel,
  showPermanentDeleteCheckbox = false,
  permanentDeleteChecked = false,
  onPermanentDeleteChange,
  permanentDeleteInfo,
}) => {
  return (
    <BaseModal open={isOpen} onClose={onCancel} size="sm">
      <ModalHeader title={title} onClose={onCancel} />

      <ModalBody>
        <p className="mb-0 text-center">{message}</p>
        {showPermanentDeleteCheckbox && (
          <div className="confirm-dialog-checkbox d-flex justify-content-center">
            <Checkbox
              label="Permanently Delete Account"
              description="Check to erase all account data."
              checked={permanentDeleteChecked}
              onChange={() => onPermanentDeleteChange?.(!permanentDeleteChecked)}
              variant="compact"
            />
          </div>
        )}
        {permanentDeleteInfo && permanentDeleteChecked && (
          <div className="alert alert-warning mt-2" style={{ fontSize: '0.95em' }}>
            {permanentDeleteInfo}
          </div>
        )}
      </ModalBody>

      <ModalFooter>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={onCancel}
        >
          {cancelIcon} Cancel
        </button>

        <button
          type="button"
          className="btn btn-primary"
          onClick={() => onConfirm(showPermanentDeleteCheckbox ? permanentDeleteChecked : undefined)}
        >
          {okIcon} Yes
        </button>
      </ModalFooter>
    </BaseModal>
  );
};

export default ConfirmDialog;
